var zo = zo || {};

// Gallery
//-----------------------------------------------------------------

zo.galleryPhotoswipe = function() {
    var $gallery = $('.js_galleryPhotoswipe');

    if (!$gallery.length) {
        return;
    }


    var $pswp = $('.pswp')[0];
    var image = [];

    $gallery.each( function() {
        var $pic     = $(this),
            getItems = function() {
                var items = [];
                $pic.find('a').each(function() {
                    var $href   = $(this).attr('href'),
                        $size   = $(this).data('size').split('x'),
                        $width  = $size[0],
                        $height = $size[1],
                        $caption = $(this).attr('data-title');

                    var item = {
                        src : $href,
                        w   : $width,
                        h   : $height,
                        title: $caption
                    };

                    items.push(item);
                });
                return items;
            };

        var items = getItems();


        $pic.on(' click', 'li', function(e) {
            e.preventDefault();
            
            $index = $('.gallery__item').index(this);

            var options = {
                index: $index,
                bgOpacity: 0.8,
                showHideOpacity: true,
                fullscreenEl: true,
                zoomEl: true,
                shareEl: true,
                counterEl: true,


                //animation
                getThumbBoundsFn: function(index) {
                    var thumbnail = e.target;
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var rect = thumbnail.getBoundingClientRect();
                    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                }//end animation
            };

            var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
            lightBox.init();
        });

    });


};


$(document).ready(function (){
    zo.galleryPhotoswipe();
});